import { useQuery } from '@tanstack/react-query'
import { locationApi } from '@/services/api'

export function useLocations() {
  const { data: continentsData } = useQuery({
    queryKey: ['continents'],
    queryFn: () => locationApi.getContinents(),
  })

  const continents = continentsData?.data?.continents || []

  const useCountries = (continent: string) => {
    const { data: countriesData, isLoading } = useQuery({
      queryKey: ['countries', continent],
      queryFn: () => locationApi.getCountries(continent),
      enabled: !!continent,
    })

    return {
      countries: countriesData?.data?.countries || [],
      isLoading,
    }
  }

  const useStates = (continent: string, country: string) => {
    const { data: statesData, isLoading } = useQuery({
      queryKey: ['states', continent, country],
      queryFn: () => locationApi.getStates(continent, country),
      enabled: !!continent && !!country,
    })

    return {
      states: statesData?.data?.states || [],
      isLoading,
    }
  }

  const useCities = (continent: string, country: string, state: string) => {
    const { data: citiesData, isLoading } = useQuery({
      queryKey: ['cities', continent, country, state],
      queryFn: () => locationApi.getCities(continent, country, state),
      enabled: !!continent && !!country && !!state,
    })

    return {
      cities: citiesData?.data?.cities || [],
      isLoading,
    }
  }

  return {
    continents,
    useCountries,
    useStates,
    useCities,
  }
}
